import { configuratorBuilder } from 'element-domain'

import { createAdminInterface } from '@salsita-ai/platform-project-sdk/admin'

export const adminInterface = createAdminInterface(configuratorBuilder)
